import React from "react";
import PropTypes from "prop-types";

import useScrollPosition from "../../../hooks/use-scroll-position";
import styles from "./styles.css";
// import ArrowIcon from "../arrow";
import Arrow from "./images/arrowup.svg";

const ScrollToTop = ({showIcon = false, threshold}) => {

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const scrollPosition = useScrollPosition();

    return (
        <div onClick={handleClick} styleName={`styles.scroll styles.dimensions ${scrollPosition > threshold ? "styles.show" : "styles.hide"}`}>
            {/* <ArrowIcon white rotateBy={180}/> */}
            {showIcon &&  <img src={Arrow} alt="arrow" />}
            Go to Top
        </div>
    );
};

ScrollToTop.propTypes = {
    threshold: PropTypes.number,
    showIcon: PropTypes.bool
};

export default ScrollToTop;
